export default __webpack_public_path__ + "static/media/finish-image.8cde75e0.svg";